export default __webpack_public_path__ + "static/media/Boots of the Swift Talon.14a03690.jpg";